import { Component, Input, OnInit } from '@angular/core';
import { EntityOrderedRequestParameters } from '@bndes/bndes-ux4/bndes-angular-utils';
import { LimiteAdicionalTrancheAgenteFinanceiro } from 'src/app/model/limite-adicional-tranche-agente-financeiro.model';
import Utils from 'src/app/shared/fgi-utils';

@Component({
  selector: 'app-limite-adicional-listagem',
  templateUrl: './limite-adicional-listagem.component.html',
  styleUrls: ['./limite-adicional-listagem.component.scss'],
  standalone: false,
})
export class LimiteAdicionalListagemComponent implements OnInit {
  @Input() public limitesAdicionais: LimiteAdicionalTrancheAgenteFinanceiro[] = [];
  @Input() public ideTranche: number;
  @Input() public permissaoGestorEnvio: boolean;
  @Input() public dataAtualizacao: Date;

  public atributosOrdenacao: EntityOrderedRequestParameters;
  public expandidos: { [ide: number]: boolean } = {};

  constructor() {}

  ngOnInit() {
    if (!this.atributosOrdenacao) {
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      };
    }
  }

  public toggleCodigos(ide: number) {
    this.expandidos[ide] = !this.expandidos[ide];
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;

    if (ord.atributo === 'valorLimite') {
      funcao = parseFloat;
    }

    this.limitesAdicionais = this.limitesAdicionais.sort((a, b) =>
      ord.sentido === 'asc'
        ? Utils.comparaComFuncao(a, b, ord.atributo, funcao)
        : -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao)
    );
  }
}